// src/Components/TopHeaderForm.jsx
import React from "react";

// ✅ Import images
import addressIcon from "../../../Assets/img/address.svg";
import emailIcon from "../../../Assets/img/email.svg";
import callIcon from "../../../Assets/img/call.svg";
import linkedinIcon from "../../../Assets/img/linkdin.svg";
import instagramIcon from "../../../Assets/img/instagram.svg";
import facebookIcon from "../../../Assets/img/facebook.svg";
import whatsappIcon from "../../../Assets/img/whatsapp.svg";

const TopHeaderForm = () => {
  return (
    <section className="top-header-form py-2">
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {/* Left: Country */}
          <div className="col-auto">
            <div className="select-wrapper">
              <select
                className="form-select text-white"
                aria-label="Select Country"
                style={{ width: "250px" }}
              >
                <option selected>India</option>
              </select>
            </div>
          </div>

          {/* Middle: Contact Info */}
          <div className="col contact-wrapper d-flex flex-wrap align-items-center gap-3 justify-content-center">
            <div className="contact-item d-flex align-items-start gap-2">
              <img src={addressIcon} alt="Address" />
              <p>
                Anaxis House, Makarba Road,
                <br />
                Ahmedabad, Gujarat, 380058.
              </p>
            </div>
            <div className="contact-item d-flex align-items-center gap-2">
              <img src={emailIcon} alt="Email" />
              <p>info@anaxistech.com</p>
            </div>
            <div className="contact-item d-flex align-items-center gap-2">
              <img src={callIcon} alt="Phone" />
              <p>+91 9023148808</p>
            </div>
          </div>

          {/* Right: Social Icons */}
          <div className="col-auto">
            <div className="social-icons d-flex gap-2">
              <a href="#">
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>
              <a href="#">
                <img src={instagramIcon} alt="Instagram" />
              </a>
              <a href="#">
                <img src={facebookIcon} alt="Facebook" />
              </a>
              <a href="#">
                <img src={whatsappIcon} alt="WhatsApp" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopHeaderForm;
